import { render, staticRenderFns } from "./positiondetail.vue?vue&type=template&id=1d673d18&scoped=true&"
import script from "./positiondetail.vue?vue&type=script&lang=js&"
export * from "./positiondetail.vue?vue&type=script&lang=js&"
import style0 from "./positiondetail.vue?vue&type=style&index=0&id=1d673d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d673d18",
  null
  
)

export default component.exports